<div class="dialog-header">
  <div class="dialog-title">
    <h1>
      {{
        id ? ("editNeed" | translate) : ("newNeed" | translate)
      }}
    </h1>
  </div>

  <a href="javascript:;" class="need-close" (click)="close()"
    ><i class="fal fa-times"></i
  ></a>
</div>

<div class="need-content">
  <nz-spin [nzSpinning]="isLoading">
    <form nz-form nzLayout="vertical" [formGroup]="form" (submit)="save()">
      <nz-form-item>
        <nz-form-label nzFor="title" nzRequired>{{
          "Naziv" | translate
        }}</nz-form-label>
        <nz-form-control>
          <input
            nz-input
            formControlName="title"
            id="title"
            [placeholder]="'title' | translate"
          />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="active">{{
          "active" | translate
        }}</nz-form-label>
        <nz-form-control >
          <nz-select formControlName="active">
            <nz-option
              [nzValue]= 'true'
              [nzLabel]="'DA' | translate"
            ></nz-option>
            <nz-option
              [nzValue]= 'false'
              [nzLabel]="'NE' | translate"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

            <nz-form-item>
        <nz-form-label nzFor="needDate" nzRequired>{{
          "date" | translate
        }}</nz-form-label>
        <nz-form-control>
          <nz-date-picker
            formControlName="needDate"
            id="needDate"
            [nzPlaceHolder]="'date' | translate"
          ></nz-date-picker>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="description">Opis</nz-form-label>
        <nz-form-control>
          <textarea
            rows="4"
            nz-input
            formControlName="description"
            id="description"
            [placeholder]="'description' | translate"
          ></textarea>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="familyId" nzRequired>{{
          "family" | translate
        }}</nz-form-label>
        <nz-form-control >
          <nz-select formControlName="familyId">
            <nz-option *ngFor="let data of dataFamilies"
              [nzValue]="data.id"
              [nzLabel]="data.representative"
            ></nz-option>         
          </nz-select>
        </nz-form-control>
      </nz-form-item>


      <div class="mt-4">
        <button nz-button nzType="primary" type="submit" [nzLoading]="isSaving">
          {{ id ? ("saveChanges" | translate) : ("add" | translate) }}
        </button>
        <button
          nz-button
          (click)="close()"
          type="button"
          class="ml-2"
          [disabled]="isSaving"
        >
          {{ "cancel" | translate }}
        </button>
      </div>
    </form>
  </nz-spin>
</div>
